import { dateFormatter } from "../../utils/tableDataFormatter";
import ReferenceConditionRenderer from "./referenceCellRenderer";

const getHeader = (name, unit) => {
  return name.replace("<unit>", `(${unit})`);
};
export const DATA_VISUALISATION_COL_DEF = (t, defaultSettingUnit) => [
  {
    headerName: t("analysisColumn.date"),
    field: "date",
    sortable: true,
    valueFormatter: dateFormatter,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },

  {
    headerName: getHeader(
      t("analysisColumn.permeateflowrate"),
      defaultSettingUnit["flow"]
    ),
    field: "permeate_flowrate",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: getHeader(
      t("analysisColumn.feedTemperature"),
      defaultSettingUnit["temperature"]
    ),
    field: "feed_temp",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: getHeader(
      t("analysisColumn.permeatePressure"),
      defaultSettingUnit["pressure"]
    ),
    field: "permeate_pressure",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: getHeader(
      t("analysisColumn.feedFlowrate"),
      defaultSettingUnit["flow"]
    ),
    field: "feed_flowrate",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: getHeader(
      t("analysisColumn.concentrateFlowrate"),
      defaultSettingUnit["flow"]
    ),
    field: "concentrate_flowrate",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: getHeader(
      t("analysisColumn.permeateQuality"),
      defaultSettingUnit["permeate_quality"]
    ),
    field: "permeate_quality",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },

  {
    headerName: getHeader(
      t("analysisColumn.feedPressure"),
      defaultSettingUnit["pressure"]
    ),
    field: "feed_pressure",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: getHeader(
      t("analysisColumn.concentratePressure"),
      defaultSettingUnit["pressure"]
    ),
    field: "concentrate_pressure",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: getHeader(
      t("analysisColumn.pressureDrop"),
      defaultSettingUnit["pressure"]
    ),
    field: "pressure_drop",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: getHeader(
      t("analysisColumn.feedQuality"),
      defaultSettingUnit["feed_quality"]
    ),
    field: "feed_quality",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: getHeader(
      t("analysisColumn.normalizedPermeateFlow"),
      defaultSettingUnit["flow"]
    ),
    field: "norm_permeate_flow",
    sortable: true,
    flex: 1,
    minWidth: 250,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: getHeader(
      t("analysisColumn.normalizedPressureDrop"),
      defaultSettingUnit["pressure"]
    ),
    field: "norm_pressure_drop",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("analysisColumn.normalizedSaltPassage"),
    field: "norm_salt_passage",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("ValueStrings.referenceCondition"),
    colId: "referenceCondition",
    lockPinned: true,
    pinned: "right",
    cellRenderer: ReferenceConditionRenderer,
  },
];
